module.exports = __webpack_public_path__ + "static/media/currency-dollar.6c650ee3.svg";